@import 'styles/mixins';
@import 'styles/variables';

.section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding-bottom: 15px;
  padding-top: 10px;
}

.headerRow {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.headerContent {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.description {
  margin: 0;
}

.bulletList {
  margin: 8px 0 0 0;
  padding-left: 20px;

  li {
    @include md-regular;
    color: var(--dark-80);
    margin-bottom: 4px;
    list-style-type: disc;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.toggleRow {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
